import React from 'react';
import {useTranslation} from 'react-i18next';
import {CheckCircle2, Info} from 'lucide-react';
import type {UserRestrictionDTO} from './AccountStanding';

interface ExcellentRequirementsProps {
    data: UserRestrictionDTO;
}

const ExcellentRequirements = ({data}: ExcellentRequirementsProps) => {
    const {t} = useTranslation();

    return (
        <div className="mt-4 rounded-xl border border-white/5 bg-white/5 p-4">
            <div className="flex items-center gap-2 mb-4">
                <Info size={15} className="text-blue-500"/>

                <span className="text-[10px] font-black uppercase tracking-widest text-gray-400">
                    {t('dashboard.profile.standing.excellent_requirements')}
                </span>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                <div className="flex items-center justify-between p-3 rounded-lg bg-black/5 dark:bg-black/20">
                    <div>
                        <p className="text-[10px] font-bold text-gray-400 uppercase">
                            {t('dashboard.profile.standing.lifetime_trades')}
                        </p>

                        <p className="text-xs font-black mt-1">
                            {data.lifetimeTradeCount} / {data.requiredLifetimeTradeCount}
                        </p>
                    </div>

                    <CheckCircle2
                        size={16}
                        className={data.lifetimeTradeCount >= data.requiredLifetimeTradeCount
                            ? 'text-emerald-500'
                            : 'text-gray-500'}
                    />
                </div>

                <div className="flex items-center justify-between p-3 rounded-lg bg-black/5 dark:bg-black/20">
                    <div>
                        <p className="text-[10px] font-bold text-gray-400 uppercase">
                            {t('dashboard.profile.standing.recent_trades')}
                        </p>

                        <p className="text-xs font-black mt-1">
                            {data.recentTradeCount} / {data.requiredRecentTradeCount}
                        </p>
                    </div>

                    <CheckCircle2
                        size={16}
                        className={data.recentTradeCount >= data.requiredRecentTradeCount
                            ? 'text-emerald-500'
                            : 'text-gray-500'}
                    />
                </div>

                <div className="flex items-center justify-between p-3 rounded-lg bg-black/5 dark:bg-black/20">
                    <div>
                        <p className="text-[10px] font-bold text-gray-400 uppercase">
                            {t('dashboard.profile.standing.clean_history')}
                        </p>

                        <p className="text-xs font-black mt-1">
                            {data.hasRecentRelevantRestriction
                                ? t('dashboard.profile.standing.not_met')
                                : t('dashboard.profile.standing.met')}
                        </p>
                    </div>

                    <CheckCircle2
                        size={16}
                        className={!data.hasRecentRelevantRestriction
                            ? 'text-emerald-500'
                            : 'text-gray-500'}
                    />
                </div>
            </div>

            <div className={`mt-3 p-3 rounded-lg border ${
                data.excellentEligible
                    ? 'bg-emerald-500/10 border-emerald-500/20'
                    : 'bg-blue-500/5 border-white/5'
            }`}>
                <p className={`text-xs font-bold ${
                    data.excellentEligible
                        ? 'text-emerald-400'
                        : 'text-gray-400'
                }`}>
                    {data.excellentEligible
                        ? t('dashboard.profile.standing.excellent_eligible')
                        : t('dashboard.profile.standing.excellent_not_eligible')}
                </p>
            </div>
        </div>
    );
};

export default ExcellentRequirements;